/* unplugin-vue-components disabled */import { render } from "./menuLeft.vue?vue&type=template&id=2cc6b4c4&scoped=true"
import script from "./menuLeft.vue?vue&type=script&lang=js"
export * from "./menuLeft.vue?vue&type=script&lang=js"

import "./menuLeft.vue?vue&type=style&index=0&id=2cc6b4c4&scoped=true&lang=css"
import "./menuLeft.vue?vue&type=style&index=1&id=2cc6b4c4&lang=css"

import exportComponent from "D:\\un-app\\ys_wuxie_webview_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc6b4c4"]])

export default __exports__